// extracted by mini-css-extract-plugin
export default {"msgM":"_517825484a"};